import React, { memo } from 'react';
import { InfoGroup, RenderRichText } from '~/ui/components';
import { TicketOriginNames } from '~/typings/enums/Ticket/TicketOrigin';
import { ServiceRecords } from '~/typings/entities/Ticket';
import { Content, Wrapper } from './ServiceExpandedRow.styles';

interface ServiceExpandedRowProps {
  service: ServiceRecords;
}

function ServiceExpandedRow({ service }: ServiceExpandedRowProps) {
  return (
    <Wrapper>
      <Content>
        <InfoGroup label="Origem do contato" value={TicketOriginNames[service?.contactOrigin]} />
        <InfoGroup label="Criado por" value={service?.user?.name} />
      </Content>
      <InfoGroup label="Descrição" value={<RenderRichText html={service?.description} />} />
    </Wrapper>
  );
}

export default memo(ServiceExpandedRow);
